import axios from '../axios'

// 文件上传
export const upload = data => {
    return axios({
        url: '/api/netdisk/upload',
        method: 'post',
        data
    })
}
